import styled from '@emotion/styled'

import media from '../../styles/media'

const S = {}

S.Form = styled.form`
  .form-checkbox {
    margin-inline: 0;
  }

  .checkmark ~ span[type='copy'] {
    html:not([dir]) &,
    [dir='ltr'] & {
      text-align: left;
    }

    [dir='rtl'] & {
      text-align: right;
    }
  }

  .checkmark svg {
    position: absolute;
    inset-block-start: 0;
    inset-inline-start: 0;
  }

  &.newsletter-form {
    .checkmark-wrapper {
      align-self: flex-start;
      margin-top: 0.125rem;
    }

    .form-checkbox {
      margin-top: 1.375rem;
    }

    .cta {
      margin-top: 2.25rem;

      ${media.sm`
        text-align: center;
        margin-top: 1.25rem;
      `};
    }

    .base-input {
      ${media.sm`
        max-width: 20.625rem;
        margin-inline: auto;
      `};
    }
  }
`

export default S
